<template>
	<div class="container-fluid">
    <div class="row bg-grey">
      <div class="col-xs-10 search-bar">
        <buscador></buscador>
      </div>
      <div class="col-xs-2">
        <div class="user-bar">
          <template v-if="getLoggedIn">
            <hola></hola>
            <router-link :to="{ name: 'consultas-pedido', params: { language:  getLocale } }" class="icon-link" active-class="active"><i class="fa fa-list-ul"></i></router-link>
            <router-link :to="{ name: 'seleccion', params: { language:  getLocale } }" class="icon-link" active-class="active"><i class="fa fa-shopping-cart"></i></router-link>
            <router-link :to="{ name: 'perfil', params: { language:  getLocale } }" class="icon-link" active-class="active"><i class="fa fa-cog"></i>
            </router-link>
          </template>
          <p v-else class="hola">&nbsp;</p>
          <a href="#" class="icon-link" @click.prevent="showModalLogin"><i class="fa fa-user-circle-o"></i></a>
        </div>
      </div>
    </div>
  </div>
</template>

<i18n>
{
  "es": {
    "Mi búsqueda": "Mi búsqueda" 
  },
  "en": {
    "Mi búsqueda": "My search"  
  },
  "ca": {
    "Mi búsqueda": "La meva cerca" 
  }
}
</i18n>

<script>
  import {mapMutations, mapGetters} from 'vuex';
  import Buscador from './Buscador.vue';
  import Hola from './usuario/Hola.vue';

	export default {
    components: { Buscador, Hola },
		data: () => {
			return{
			}
		},
    mounted(){
      /* if( this.getRouteLogin ){
        this.showModalLogin();
      } */
    },
    computed: {
      ...mapGetters(['getLocale', 'getLoggedIn', 'getRouteLogin']),
    },
    methods: {
      ...mapMutations(['showModalLogin']),
    },
    watch: {
    }
  }
</script>